// @flow

import React from 'react';
import Tooltip from '../../../../components/Tooltip';
import type { kpiData } from '../../../../types/geminiType';

type Props = {
  selectedData: kpiData[],
  isButton: boolean,
}

function Analysis({ selectedData, isButton }: Props) {
  return (
    <div className="gemini-kpi-comparable-container">
      <div className="kpi-selector-container">
        {
          selectedData.map((data, index) => (
            <div className="kpi-selector-row" key={data.label}>
              <button
                key={data.label}
                className={`kpi-selector ${(isButton && data.isSelected) ? 'selected' : ''} ${data.classname || ''}`}
                onClick={() => {
                  if (isButton) {
                    data.onClick();
                  }
                }}
              >
                <Tooltip>
                  {data.subtitle}
                </Tooltip>
                <div>
                  <div>{data.label}</div>
                  <div className="subtitle">
                    {data.subtitle}
                  </div>
                </div>
                <div className="kpi-selector-value">{data.value}</div>
              </button>
              <div
                className={(isButton && data.isSelected) ? 'arrow-right' : ''}
              />
            </div>
          ))
        }
      </div>
    </div>
  );
}

export default Analysis;
